import { namespacer } from 'helpers'

const namespace = namespacer('BUDDY_MATCH')
export const BUDDY_REQUEST_SUCCESS = namespace('BUDDY_REQUEST_SUCCESS')
